import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

export const tagRuleEditSchema = z.object({
  id: z
    .string()
    .nullish()
    .superRefine(
      fieldConfig({
        inputProps: {
          disabled: true,
        },
      }),
    ),
  tag_name: z.string().min(1),
  explanation: z
    .string()
    .min(1)
    .superRefine(
      fieldConfig({
        fieldType: "textarea",
      }),
    ),
  enabled: z.boolean().default(true),
});

export type TagRuleEditFormType = z.infer<typeof tagRuleEditSchema>;
